import React, { Dispatch, SetStateAction, useState } from "react";

import { PatentSearchFilterType } from "@/components/business/PatentContainer/patentList.types";
import SearchInput from "@atoms/SearchInput/SearchInput";
import { usePatentListFilterState } from "@stores/patentList";

import {
  PATENT_LIST_EDITOR_INFO_FILTER,
  PATENT_LIST_EDITOR_INFO_FILTER_KEY,
} from "./constants/editorInfoFilter.constants";
import * as S from "./PatentEditorInfoSearch.style";
import PatentSearchFilterSelect from "../PatentPressInfoSearch/components/PatentSearchFilterSelect/PatentSearchFilterSelect";

interface Props {
  currentEditorFilter: PatentSearchFilterType;
  setCurrentFilter: Dispatch<SetStateAction<PatentSearchFilterType>>;
}

const PatentEditorInfoSearch = ({
  currentEditorFilter,
  setCurrentFilter,
}: Props) => {
  const [patentListFilter, setPatentListFilter] = usePatentListFilterState();
  const [typing, setTyping] = useState("");

  const { search } = patentListFilter;

  const handleSearchKeyboard = () => {
    const currentInput = typing.trim();

    const newSearch = { ...search };
    PATENT_LIST_EDITOR_INFO_FILTER_KEY.forEach((key) => delete newSearch[key]);
    newSearch[currentEditorFilter.key] = currentInput;

    if (currentInput) {
      setPatentListFilter({
        ...patentListFilter,
        search: newSearch,
        page: 1,
      });
    }
  };

  const handleSearchButton = () => {
    const currentInput = typing || search?.[currentEditorFilter.key];

    const newSearch = { ...search };
    PATENT_LIST_EDITOR_INFO_FILTER_KEY.forEach((key) => delete newSearch[key]);
    newSearch[currentEditorFilter.key] = currentInput;

    if (currentInput) {
      setPatentListFilter({
        ...patentListFilter,
        search: newSearch,
        page: 1,
      });
    }
  };

  return (
    <S.EditorInfoSearchWrapper>
      <PatentSearchFilterSelect
        subTitle="Editor Filter"
        filterList={PATENT_LIST_EDITOR_INFO_FILTER}
        currentFilter={currentEditorFilter}
        setCurrentFilter={setCurrentFilter}
        isEditor
      />
      <SearchInput
        placeholder="Search Editors"
        inputWidth={20.8}
        onSearchButton={handleSearchButton}
        handleSearchKeyboard={handleSearchKeyboard}
        typing={typing}
        setTyping={setTyping}
      />
    </S.EditorInfoSearchWrapper>
  );
};

export default PatentEditorInfoSearch;
